import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

import { TRACKING_PROVIDER } from "../../config/tracking/providers";

import TrackingUtil from "../../utils/tracking";
import { ENV } from "../../constants/environment";

const { REACT_APP_ENV, REACT_APP_NETCORE_SMARTECH_PANEL_ID, REACT_APP_NETCORE_WEBSITE_ID } = process.env;

const NetCore = () => {
  /**
   * NOTE: THE ANALYTIC LIBRARY IS NOT LOADED IN THIS COMPONENT
   *       IT IS LOADED DIRECTLY AT 'index.html' <head> section.
   *       This useEffect snippet is just for extra initialization
   *        using `TrackingUtil.initConfigForProvider()`
   * */
  useEffect(() => {
    if (!TrackingUtil.isProviderEnabled(TRACKING_PROVIDER.NETCORE)) {
      return;
    }

    const cancelInitConfig = TrackingUtil.initConfigForProviderWhenReady(TRACKING_PROVIDER.NETCORE);
    const cancelPageView = TrackingUtil.sendPageViewForProviderWhenReady(TRACKING_PROVIDER.NETCORE);

    return () => {
      cancelInitConfig();
      cancelPageView();
      TrackingUtil.stopTrackingForProvider(TRACKING_PROVIDER.NETCORE);
    };
  }, []);

  /**
   * NOTE: ON LOCALHOST, NETCORE API KEY NEEDS TO BE REGISTERED LOCALLY
   *       For staging and prod, marketing will inject the setup via GTM,
   *       so we just have to load GTM as usual, and it will
   *       load netcore SDK + register the api key for us, on the cloud.
   * */
  return (REACT_APP_ENV == ENV.LOCAL || REACT_APP_ENV == ENV.DEV) && TrackingUtil.isProviderEnabled(TRACKING_PROVIDER.NETCORE) ? (
    <Helmet>
      {/* <!-- NetCore Register via code for LOCALHOST only. --> */}
      <script>
        {`smartech('create', '${REACT_APP_NETCORE_SMARTECH_PANEL_ID}' );
          smartech('register', '${REACT_APP_NETCORE_WEBSITE_ID}');`}
      </script>
    </Helmet>
  ) : null;

  // (
  //   TrackingUtil.isProviderEnabled(TRACKING_PROVIDER.NETCORE) && (
  //     <Helmet>
  //       {/* <!-- NetCore Code --> */}
  //       {/* https://developer.netcorecloud.com/docs/web-sdk-integration */}

  //       {/* A. Netcore official script, have issue of delayed injection to window.smartech */}
  //       {/* <script src="https://cdnt.netcoresmartech.com/smartechclient.js" />
  //       <script>
  //         {`smartech('create', 'ADGMOT35CHFLVDHBJNIG50K96AMBHGB8G1FSGTKICSMO65FBTQQG' );
  //           smartech('register', '2df8afa4e74d8bcd8866c0d379b0e00e');`}
  //       </script> */}

  //       {/* B. Custom script, but still unable to solve issue of delayed injection to window.smartech */}
  //       {/* <script id="netcore-script">
  //         {`!function(n,e,t,c,o,r){
  //         if(n.smartech)return;
  //         o=e.createElement(t);o.async=!0;o.src=c;
  //         r=e.getElementsByTagName(t)[0];r.parentNode.insertBefore(o,r);
  //       }(window,document,'script','https://cdnt.netcoresmartech.com/smartechclient.js');
  //       //const netcoreLoadedEvent = new Event('smartech.loaded');
  //       //window.dispatchEvent(netcoreLoadedEvent);`}
  //       </script> */}
  //       {/* <!-- End NetCore Code --> */}
  //       {/* <noscript id="netcore-noscript"></noscript> */}
  //     </Helmet>
  //   )
};

export default NetCore;
